import util from '@/libs/util'
import { AccountLogin, Accountlogout } from '@/api/user'
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login ({ dispatch, commit }, {
      vm,
      username,
      password
    }) {
      // 开始请求登录接口
      return new Promise((resolve, reject) => {
        AccountLogin({
          username,
          password
        }).then(async res => {
          // token 代表用户当前登录状态 建议在网络请求中携带 token
          // 如有必要 token 需要定时更新，默认保存一天
          util.cookies.set('token', res.data.employee.token)
          util.cookies.set('employeeId', res.data.employee.employeeId)
          util.cookies.set('userName', res.data.employee.employeeAccount)
          localStorage.setItem('storeId', res.data.employee.storeId || '')
          commit('setTagNavList', [], {root: true})
          resolve(res)
          // 结束
        }).catch(err => {
          reject(err)
        })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout ({ commit }, { vm, confirm = false }) {
      /**
       * @description 注销
       */
      function logout () {
        Accountlogout().then(() => {
          // 删除cookie
          util.cookies.remove('token')
          vm.$router.push({name: 'Login'})
        }).catch(e => {
          console.log(e)
        })
      }
      // 判断是否需要确认
      confirm = Boolean(util.cookies.get('token'))
      if (confirm) {
        vm.$Modal.confirm({
          content: '<div class="tip_text"><i class="iconfont icon-tishi"></i><p>确定退出当前系统吗？</p></div>',
          onOk: () => {
            logout()
          },
          onCancel: () => {
            console.log('放弃注销用户')
          }
        })
      } else {
        logout()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/account.js